import { createRouter, createWebHistory } from "vue-router";

// Import your components
import Home from "./pages/home.vue";
import LoginPage from "./pages/LoginPage.vue";
import QuranPrograms from "./pages/quranPrograms.vue";
const routes = [
  { path: "/", component: Home },
  { path: "/login", component: LoginPage },
  { path: "/quran_programs" , component : QuranPrograms}
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
